import { render, staticRenderFns } from "./AddressValidatorModal.vue?vue&type=template&id=4b99e400&"
import script from "./AddressValidatorModal.vue?vue&type=script&lang=js&"
export * from "./AddressValidatorModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports